<div class="tc-shell">

  <!-- Header -->
  <div class="tc-header">
    <div class="tc-title">
      <span nz-icon nzType="table" class="tc-title-icon"></span>
      <span class="tc-title-text">{{ item.title }}</span>
      <nz-divider nzType="vertical"></nz-divider>
      <button nz-button nzSize="small" nzShape="round" (click)="exportCsv()" *ngIf="canExport"
        nz-tooltip nzTooltipTitle="Exportar CSV">
        <nz-icon nzType="custom:excel" />
      </button>
    </div>
    <div class="tc-actions">
      <button nz-button nzType="text" nzShape="circle" *ngIf="showConfiguration"
        nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
        <span nz-icon nzType="more"></span>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="openConfiguration()">
            <span nz-icon nzType="setting" class="tc-menu-icon"></span>
            <span>Configurações</span>
          </li>
          <li nz-menu-item (click)="deletePreference()">
            <span nz-icon nzType="clear" class="tc-menu-icon"></span>
            <span>Remover Preferências</span>
          </li>
          <li nz-menu-item nzDanger (click)="excluir()">
            <span nz-icon nzType="delete" class="tc-menu-icon"></span>
            <span>Excluir</span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>

  <!-- Grid -->
  <div class="tc-grid-wrapper">
    <nz-spin class="tc-spin" [nzSpinning]="isRefreshing" nzSize="large">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      [class]="(ThemeService.theme) ? 'ag-theme-quartz-dark' : 'ag-theme-quartz'"
      [columnTypes]="columnTypes"
      (columnResized)="onResize($event)"
      (gridReady)="onGridReady($event)"
      (columnPinned)="onPinned($event)"
      (columnMoved)="onReoder($event)"
      (filterChanged)="onFilterChanged($event)"
      [suppressDragLeaveHidesColumns]="true"
      (rowSelected)="selectedData($event)"
      [localeText]="ls.getCurrentGridLocale()"
      overlayNoRowsTemplate="Não encontrado nenhum resultado"
      [rowBuffer]="150"
      rowSelection="multiple"
      [copyHeadersToClipboard]="true"
      (sortChanged)="sortChanged()"
      multiSortKey="ctrl"
      [pagination]="showPagination"
      [enableCellTextSelection]="canClipboard"
      [suppressClipboardPaste]="true">
    </ag-grid-angular>
    </nz-spin>
  </div>

  <!-- Footer -->
  <div class="tc-footer" *ngIf="item.refresh != null && item.refresh > 0">
    <span class="tc-last-update">
      <span nz-icon nzType="clock-circle" class="tc-last-update-icon"></span>
      Última Atualização: {{ lastUpdate }}
    </span>
  </div>

  <nz-float-button
    class="tc-refresh-btn"
    nzShape="circle"
    nzType="primary"
    (nzOnClick)="reload()"
    [nzIcon]="isRefreshing ? 'loading' : 'sync'">
  </nz-float-button>
</div>
